function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState } from 'react';
import { AppBar, Toolbar, Link, Container, Box, Typography, Button, TextField } from '@material-ui/core';
import { makeStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import InfoIcon from '@material-ui/icons/Info';
import './App.css'; // import logo from './logo.svg';

import CustomBlockchain from "./shared/CustomBlockchain.js";
import { with2Decimals, numberWithSpaces } from "./shared/helpers.js"; // const json_cache = require('./cache/CACHE_delphe_explorer_length1016910.json')

var json_cache = require('./cache/CACHE_delphe_explorer_length3130261');

var IDBExportImport = require("@sighmir/indexeddb-export-import"); // ************************************************


var contract_origin = "f597770adc303efe702fcc1497b87703d166adc9d2a5a4cd8e92c571b2324201_o1";
var networkRetries = 5; // default is 2

var minutes = 60 * 1000; // in ms

var TIMEOUTS = 10 * minutes; // we need a huge timeout for the scaleway server
// TODO remove mattercloud since it was deprecated

var mattercloud_APIkey = "3Qw5kc39jAbaHnmH5uvqJzB6C4BiqLRC7D6ChFWhC7bVGq1neznJyBNWd4m4ajEB9F"; // ************************************************

var Run = window.Run;
console.log(">>> Run=", Run);
var total_mult = null,
    supply_premult = null; // global vars so we can reuse them
// global single run instance

var run_options = {
  trust: '*',
  timeout: TIMEOUTS,
  // in ms, for RUN actions
  networkTimeout: TIMEOUTS,
  // in ms, for network requests
  networkRetries: networkRetries
};
var run = new Run(_objectSpread({}, run_options));
run_options.cache = run.cache;
run.blockchain = new CustomBlockchain(run_options, mattercloud_APIkey);
run.backingLimit = 10 * 1000 * 1e8; // allow up to 10k bsv in backed jigs

run.activate();

function load_json_cache() {
  return _load_json_cache.apply(this, arguments);
}

function _load_json_cache() {
  _load_json_cache = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var idbDatabase_request;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            idbDatabase_request = window.indexedDB.open("run-browser-cache", 1); // 2nd arg is version

            console.log("load_json_cache(): idbDatabase_request=", idbDatabase_request);

            idbDatabase_request.onsuccess = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(event) {
                var idbDatabase;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        idbDatabase = idbDatabase_request.result;
                        console.log("load_json_cache(): json_cache = ", json_cache);
                        _context5.next = 4;
                        return IDBExportImport.importFromObject(idbDatabase, json_cache);

                      case 4:
                        console.log("load_json_cache(): Imported json_cache successfully");

                      case 5:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }();

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _load_json_cache.apply(this, arguments);
}

load_json_cache(); // const trust_list = [
//   contract_origin,
// ]
// const unban_list = [
//   "bb5535208321614d8e0121e2651c63271b8400929013dfea2dbf55047689113e_o1",
//   "da640f8a19e7608f5937e2015fd5fe83a397e24886fecb05232a07638055f3ae_o1",
//   "132a6549380ab16a6974dc594915ca01bff63d309700bb90171aaf81a6bf086b_o2",
//   "44b96c65dc83cf9f6acc6b5d41878099de10d7a2be91c51e3c8d62955375c7b0_o1",
//   "de2a958d47ba6e41ab88b1d5cda91c583e3a0eb337808b01862d715d476d6235_o2"
// ]

var theme = createTheme({
  palette: {
    type: "dark"
  }
});
var classes = makeStyles(function (theme) {
  return {
    toolbar: _objectSpread(_objectSpread({}, theme.mixins.toolbar), {}, {
      backgroundColor: "red"
    })
  };
});

function MyTextField(props) {
  return /*#__PURE__*/React.createElement(TextField, {
    id: "filled-full-width",
    label: props.label,
    style: {
      margin: 8
    },
    placeholder: props.placeholder,
    fullWidth: true,
    margin: "normal",
    InputLabelProps: {
      shrink: true
    },
    variant: "filled",
    color: "secondary",
    onChange: props.onChange
  });
}

function App() {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      address = _useState2[0],
      set_address = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      set_error = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      result = _useState6[0],
      set_result = _useState6[1];

  var _useState7 = useState("Loading"),
      _useState8 = _slicedToArray(_useState7, 2),
      delphe_supply = _useState8[0],
      set_delphe_supply = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      is_updating_delphe_supply = _useState10[0],
      set_is_updating_delphe_supply = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      is_onExplore = _useState12[0],
      set_is_onExplore = _useState12[1];

  function update_delphe_supply() {
    return _update_delphe_supply.apply(this, arguments);
  }

  function _update_delphe_supply() {
    _update_delphe_supply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var contract, mult_list, new_supply;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!is_updating_delphe_supply) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              set_is_updating_delphe_supply(true);

              if (!isNaN(delphe_supply)) {
                _context3.next = 20;
                break;
              }

              if (!(!total_mult || !supply_premult)) {
                _context3.next = 16;
                break;
              }

              run.activate();
              _context3.next = 8;
              return run.load(contract_origin);

            case 8:
              contract = _context3.sent;
              _context3.next = 11;
              return contract.sync();

            case 11:
              console.log("contract_origin latest location:", contract.location);
              supply_premult = contract.supply;
              mult_list = contract.multlist.list;
              total_mult = mult_list.reduce(function (a, b) {
                return a * b;
              }, 1);
              console.log("\n supply_premult=", supply_premult, "\n mult_list=", mult_list, "\n total_mult=", total_mult);

            case 16:
              new_supply = supply_premult * total_mult * 1e-8;
              console.log("update_delphe_supply(): new_supply=", new_supply);
              set_delphe_supply(new_supply); // keep as number because we check with isNaN()0  

              set_is_updating_delphe_supply(false);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _update_delphe_supply.apply(this, arguments);
  }

  var delphe_supply_str = "";

  if (isNaN(delphe_supply)) {
    update_delphe_supply();
    delphe_supply_str = delphe_supply;
  } else {
    delphe_supply_str = numberWithSpaces(with2Decimals(delphe_supply));
  }

  function onExplore(_x) {
    return _onExplore.apply(this, arguments);
  }

  function _onExplore() {
    _onExplore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
      var final_address, tokens, amounts, amount_total, contract, token_total, token_total_str;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e.preventDefault();

              if (!is_onExplore) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              set_is_onExplore(true); // reset

              set_error("");
              set_result(null);
              final_address = address;
              console.log("onExplore");
              _context4.prev = 8;

              if (final_address.includes("delphe:")) {
                final_address = final_address.split('delphe:')[1];
              }

              console.log("final_address=", final_address); // var run = new Run({
              //   owner: final_address,
              //   trust: '*',
              // })

              run.owner = new Run.plugins.Viewer(final_address);
              console.log("run =", run); // var cache_unban = unban_list.map(async (runtxid)=>
              //   await run.cache.set('ban://' + runtxid, false)
              // )
              // console.log("cache_unban = ",cache_unban)
              // await Promise.all(cache_unban)
              // trust_list.map(txid=>
              //   run.trust(txid)
              // )        

              set_result("Loading... ");
              console.log("syncing...");
              _context4.next = 17;
              return run.sync();

            case 17:
              _context4.next = 19;
              return run.inventory.sync();

            case 19:
              console.log("inventory =", run.inventory);
              console.log("inventory.jigs =", run.inventory.jigs);

              if (!(run.inventory.jigs.length > 0)) {
                _context4.next = 41;
                break;
              }

              tokens = run.inventory.jigs.filter(function (jig) {
                return jig.constructor.origin === contract_origin;
              });
              amounts = tokens.map(function (jig) {
                return jig.amount;
              });
              amount_total = amounts.reduce(function (a, b) {
                return a + b;
              }, 0);

              if (total_mult) {
                _context4.next = 35;
                break;
              }

              run.activate();
              _context4.next = 29;
              return run.load(contract_origin);

            case 29:
              contract = _context4.sent;
              _context4.next = 32;
              return contract.sync();

            case 32:
              console.log("contract_origin latest location:", contract.location);
              supply_premult = contract.supply;
              total_mult = contract.multlist.list.map(function (a) {
                return a;
              }).reduce(function (a, b) {
                return a * b;
              }, 1);

            case 35:
              token_total = amount_total * total_mult * 1e-8;
              console.log("token_total = ", token_total);
              token_total_str = delphe_supply_str = numberWithSpaces(with2Decimals(token_total));
              set_result(token_total_str + " delphes found on " + final_address);
              _context4.next = 42;
              break;

            case 41:
              set_result("0 delphes found on " + final_address);

            case 42:
              _context4.next = 48;
              break;

            case 44:
              _context4.prev = 44;
              _context4.t0 = _context4["catch"](8);
              console.error(_context4.t0);
              set_error("Error: " + _context4.t0.message);

            case 48:
              set_is_onExplore(false);

            case 49:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[8, 44]]);
    }));
    return _onExplore.apply(this, arguments);
  }

  var downloadCacheFile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var idbDatabase_request;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // export to JSON string, clear database, and import from JSON string
              idbDatabase_request = window.indexedDB.open("run-browser-cache", 1); // 2nd arg is version

              console.log("downloadCacheFile(): idbDatabase_request=", idbDatabase_request);

              idbDatabase_request.onsuccess = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
                  var idbDatabase, exportObject, jsonString, element, file;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          idbDatabase = idbDatabase_request.result;
                          _context.next = 3;
                          return IDBExportImport.exportToObject(idbDatabase);

                        case 3:
                          exportObject = _context.sent;
                          console.log("Exported as JSON: ", exportObject); //
                          // export to json file
                          //

                          jsonString = JSON.stringify(exportObject);
                          element = document.createElement("a"); // const file = new Blob([document.getElementById('myInput').value], {type: 'text/plain'});
                          //const file_content_as_str = "hello world :)"

                          file = new Blob([jsonString], {
                            type: 'text/plain'
                          });
                          element.href = URL.createObjectURL(file);
                          element.download = "CACHE_delphe_explorer_length" + jsonString.length + ".json";
                          document.body.appendChild(element); // Required for this to work in FireFox

                          element.click();
                          _context.next = 14;
                          return IDBExportImport.clearDatabase(idbDatabase);

                        case 14:
                          console.log('cleared data successfully');
                          _context.next = 17;
                          return IDBExportImport.importFromObject(idbDatabase, exportObject);

                        case 17:
                          console.log("Imported data successfully");

                        case 18:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function downloadCacheFile() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: "App"
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "static",
    style: {
      backgroundColor: "darkred"
    }
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement(Link, {
    href: "#",
    variant: "h5",
    color: "inherit",
    underline: "none"
  }, /*#__PURE__*/React.createElement("img", {
    src: "mui-assets/img/logo-pied-piper-white.png",
    alt: "",
    width: "120"
  })), /*#__PURE__*/React.createElement("b", null, "Delphe Explorer"), " \xA0 \xA0 (v 0.1.1)")), /*#__PURE__*/React.createElement("header", {
    className: "App-header",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Container, {
    maxWidth: "md"
  }, /*#__PURE__*/React.createElement(Box, {
    py: 4,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "10vh"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    component: "h2",
    gutterBottom: true
  }, "Explorez une adresse Delphe sur la blockchain"), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "10vh"
    }
  }), /*#__PURE__*/React.createElement(MyTextField, {
    label: "Delphe address",
    placeholder: "delphe:15uX8W2NTcetRSVURJHaCJr7RnY3Pb7SUu",
    onChange: function onChange(v) {
      return set_address(v.target.value);
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "red",
      fontSize: "0.7em"
    }
  }, error), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "#8bc34a",
      fontSize: "0.7em"
    }
  }, result), /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    className: classes.secondaryAction,
    onClick: onExplore
  }, "Explorer"))))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("section", null, "\xA0", /*#__PURE__*/React.createElement(Alert, {
    icon: /*#__PURE__*/React.createElement(InfoIcon, {
      fontSize: "inherit",
      style: {
        color: "white"
      }
    }),
    severity: "error",
    style: {
      width: "fit-content",
      margin: "0 auto",
      borderRadius: "10em",
      paddingTop: "10px",
      backgroundColor: "rgb(139 0 0)",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement(AlertTitle, null, delphe_supply_str, " Delphes en circulation\xA0 "))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: downloadCacheFile,
    style: {
      color: "#282c34"
    }
  }, "download cache"))));
}

export default App;